
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/budget-calculator",
      function () {
        return require("private-next-pages/tools/budget-calculator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/budget-calculator"])
      });
    }
  